import imageEditor from '../../../../common/components/image-editor/image-editor.vue';
import { ROUTE_NAMES } from '../../constants/oki-constants';
import VueFormNotification from '@ui-common/vue-form-notification';
import VueModal from '@ui-common/vue-modal';

export default {
	data() {
		return {
			model: {
				nameOnCard: '',
				dailyCashWithdrawalLimit: null,
				dailyPurchaseLimit: null,
				equalWithCreditLine: false,
				repaymentMethod: null,
				repaymentAccountNumber: '',
				monthlyRepaymentInformationSMS: '',
				smsPhone: null,
				repaymentInsurance: null,
				healthStatusDecline: null,
				handoverBranchCounty: null,
				handoverBranchDistrict: null,
				handoverBranchCode: null
			},
			bankBranchSelectorData: {},
			backBranchFormSubmitted: false,
			loading: false,
			buttonDisabled: true
		};
	},
	props: {
		bankAccountNumber: {},
		cardData: {
			required: true
		},
		image: {
			required: true
		},
		visitedSummary: {
			required: true
		}
	},
	components: {
		VueModal,
		imageEditor,
		VueFormNotification
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	methods: {
		waitAndRender() {
			if (this.$refs.loadingDiv.offsetHeight) {
				setTimeout(() => {
					this.$refs['image-editor-component'].crop();
				});
			} else {
				window.requestAnimationFrame(this.waitAndRender);
			}
		},
		postCardImageForm() {
			if (this.$refs['image-editor-component']) {
				this.loading = true;
				this.waitAndRender();
			} else {
				this.$router.push(ROUTE_NAMES.OSSZEGZES);
			}
		},
		setButtonDisabled(editorVisible) {
			this.buttonDisabled = !editorVisible;
		},
		postImages(dataUrls) {
			this.$emit('save-images', dataUrls);
		}
	}
};
